import React, { useEffect } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { useDispatch } from 'react-redux';
import Dashboard from './pages/Dashboard';
import Home from './pages/Home/Home';
import InvalidRoute from './pages/Validate/InvalidRoute';
import VerifyNotesLink from './pages/Validate/VerifyNotesLink';
import StartSubmission from './pages/Validate/StartSubmission';
import TrialClassRecordings from './pages/UserPages/TrialClassRecordings';
import SubTopicListPage from './pages/QuestionPages/SubTopicListPage';
import QuestionsPage from './pages/QuestionPages';
import Payment from './pages/Payment';
import ManageSubscriptions from './pages/Payment/ManageSubscriptions';
import { useAppSelector } from './hooks';
import { getMetaTagState } from './store/MetaTagSlice';
import { getMetaTags } from './store/MetaTagSlice/MetaTagApi';

const BaseRoute: React.FC = () => {
  const location = useLocation();
  const dispatch = useDispatch();

  // State
  const metaTagState = useAppSelector(getMetaTagState);

  useEffect(() => {
    dispatch(
      getMetaTags({
        path: encodeURIComponent(location.pathname.replace(/[/]$/, '')),
      })
    );
  }, [location]);

  return (
    <>
      {metaTagState.metaTags &&
        metaTagState.metaTags[location.pathname.replace(/[/]$/, '')] && (
          <Helmet>
            <title>
              {
                metaTagState.metaTags[location.pathname.replace(/[/]$/, '')]
                  .title
              }
            </title>
            <meta
              name="description"
              content={
                metaTagState.metaTags[location.pathname.replace(/[/]$/, '')]
                  .description
              }
            />
          </Helmet>
        )}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route
          path="/trial-recording/:trialId"
          element={<TrialClassRecordings />}
        />
        <Route path="/dashboard/*" element={<Dashboard />} />
        <Route path="/:curriculum" element={<Home />} />
        <Route path="/verifyNotesLink" element={<VerifyNotesLink />} />
        <Route path="/startSubmission/:quizId" element={<StartSubmission />} />
        <Route path="/payment/:diagnosticId" element={<Payment />} />
        <Route path="/*" element={<InvalidRoute />} />
        <Route path="/subscriptions" element={<ManageSubscriptions />} />

        <Route path="/:curriculum/:subject" element={<SubTopicListPage />} />
        <Route path="/:curriculum/:subject/*" element={<QuestionsPage />} />
      </Routes>
    </>
  );
};

export default BaseRoute;
